const intFlightData = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_INT_FLIGHT_DATA':
            return action.intFlightData
        default:
            return state
    }
}

export default intFlightData